module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_diamonds-ace.1eff42c7.svg";